var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0017 19.1082L18.2018 15.3082C19.1139 13.9334 19.6478 12.2874 19.6478 10.5178C19.6478 5.72309 15.747 1.82227 10.9523 1.82227C6.15754 1.82227 2.25671 5.72309 2.25671 10.5178C2.25671 15.3126 6.15754 19.2134 10.9523 19.2134C12.7218 19.2134 14.3679 18.6795 15.7427 17.7673L19.5417 21.5673C19.8817 21.9073 20.4322 21.9073 20.7713 21.5673L22.0008 20.3377C22.3408 19.9977 22.3417 19.4473 22.0017 19.1082ZM3.99583 10.5178C3.99583 6.68221 7.11666 3.56138 10.9523 3.56138C14.7879 3.56138 17.9087 6.68221 17.9087 10.5178C17.9087 14.3534 14.7879 17.4743 10.9523 17.4743C7.11666 17.4743 3.99583 14.3534 3.99583 10.5178Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.cc7dff73c688bcfd71fe4962cf178f84.svg";
export { ForwardRef as ReactComponent };